module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_03-fcfd66bdd2a1b4d2485f679881ed6f4b.jpg";